<template>
  <div class="container">
    <DataGetter
      :url="`${apiRoute}/dashboard`"
      :params="{
        region: selectedRegion,
        product: 'Liquid biofuels',
        flow: indicatorFlows,
      }"
      :childElementType="null"
      :initialData="
        indicatorFlows.reduce((flows, flow) => {
          if (
            flow === '5 year CAGR biofuels consumption' ||
            flow === 'Forecast revision'
          ) {
            flows.push({ flow, value: 0 });
          } else {
            flows.push({ flow, value: 0, year: 2022 });
            flows.push({ flow, value: 0, year: 2028 });
          }
          return flows;
        }, [])
      "
      v-slot="{ data }"
    >
      <IndicatorBox
        key="transport-indicators"
        :title="`Key transport indicators, ${selectedRegion}`"
        :indicators="
          data
            .toSorted(
              (a, b) =>
                indicatorFlows.indexOf(a.flow) - indicatorFlows.indexOf(b.flow)
            )
            .map((row) => ({
              title:
                row.flow === 'Forecast revision'
                  ? 'Forecast revision from Renewables 2022'
                  : `${row.flow}${
                      row.year && row.year !== 'NOTAPPLICABLE'
                        ? `, ${row.year}`
                        : ''
                    }`,
              text:
                row.flow === 'Forecast revision' && isNaN(parseInt(row.value))
                  ? row.value
                  : null,
              number: isNaN(parseInt(row.value))
                ? null
                : parseFloat(parseFloat(row.value).toFixed(0)),
              invalid: !row.value,
              units: row.unit,
              description: row.year === 2028 ? 'Forecast' : null,
              arrow: row.flow === 'Forecast revision',
              info:
                row.flow === 'Forecast revision' && isNaN(parseInt(row.value))
                  ? '<p>When the forecast has changed from negative to positive, or vice versa, the numerical change cannot be computed.</p>'
                  : null,
            }))
        "
        :notes="countryNotes[selectedRegion]"
        compact
      >
      </IndicatorBox>
    </DataGetter>
    <ControlGroup>
      <ButtonGroup
        :options="
          ['Consumption', 'Production', 'Feedstock'].map((value) => ({
            label: value,
            value,
          }))
        "
        v-model="selectedFlow"
        fixed
      />
    </ControlGroup>
    <DataGetter
      :url="endpoint"
      :params="{
        region: selectedRegion,
        publication: publication,
        product: useProducts,
      }"
      class="m-block m-block--charts m-block--charts-half"
      v-slot="{ data }"
      :initialData="[]"
    >
      <FiveYearChart
        :selectedRegion="selectedRegion"
        :selectedFlow="selectedFlow"
        :title="
          selectedFlow === 'Feedstock'
            ? `5-year growth`
            : `5-year ${selectedFlow.toLowerCase()} growth`
        "
        :products="useProducts"
        :productLabel="selectedFlow === 'Feedstock' ? 'Feedstock' : 'Fuel'"
        showAll
        computeGrowth
        :data="data"
      />
      <TimeSeriesChart
        :selectedRegion="selectedRegion"
        :products="useProducts"
        :selectedFlow="selectedFlow"
        allowCaseSelection
        :data="data"
      />
    </DataGetter>
    <TextContent
      product="Liquid biofuels"
      :region="selectedRegion"
      :apiRoute="apiRoute"
      :publication="publication"
    />
  </div>
</template>

<script>
import {
  DataGetter,
  ControlGroup,
  ButtonGroup,
  IndicatorBox,
} from "@international-energy-agency/vue-ui";
import TextContent from "./TextContent.vue";
import FiveYearChart from "./FiveYearChart.vue";
import TimeSeriesChart from "./TimeSeriesChart.vue";
export default {
  components: {
    DataGetter,
    ControlGroup,
    ButtonGroup,
    IndicatorBox,
    FiveYearChart,
    TimeSeriesChart,
    TextContent,
  },
  data() {
    return {
      projectionYear: 2022,
      selectedFlow: "Consumption",
      fuels: ["Ethanol", "Biodiesel", "Renewable Diesel", "Biojet"],
      feedstocks: [
        "Sugars",
        "Starch",
        "Vegetable oils",
        "Fats, oils and greases",
        "Other residues",
      ],
      indicatorFlows: [
        "Biofuel share of road transport fuel demand (energy basis)",
        "Total road fuel demand",
        "5 year CAGR biofuels consumption",
        "Forecast revision",
      ],
    };
  },
  props: {
    apiRoute: {
      type: String,
      default: "https://api.iea.org",
    },
    publication: {
      type: String,
      default: "Renewables 2023",
    },
    selectedRegion: {
      type: String,
      required: true,
    },
    countryNotes: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    endpoint() {
      const { apiRoute } = this;
      return `${apiRoute}/transport`;
    },
    useProducts() {
      const { selectedFlow } = this;
      return selectedFlow === "Feedstock" ? this.feedstocks : this.fuels;
    },
  },
};
</script>

<style scoped>
.case-select {
  flex: unset !important;
}
</style>